/**
 * A department is unavailable for new work when it has an archived timestamp or has been deleted.
 * `status === 'archived'` is deliberately ignored: reactivated departments can retain that status
 * with a null `archivedAt`, so the timestamp is the source of truth.
 */
export const isDepartmentArchived = department => !!department && (!!department.archivedAt || department.status === 'deleted');

/**
 * @param {Array} departments
 * @returns {Array} the departments that can be assigned to projects
 */
export const activeDepartments = departments => (departments || []).filter(department => !isDepartmentArchived(department));

/**
 * Maps a company department to a dropdown option, keeping the fields `activeDepartments` filters on.
 */
export const toDepartmentOption = ({ departmentName, departmentId, archivedAt, status }) => ({
  label: departmentName,
  id: departmentId,
  archivedAt,
  status
});
